import { createAction, props } from '@ngrx/store';

export const testMonkeyUpdateResponses = createAction(
  '[Test Monkey] Update Responses',
  props<{ payload: any }>(),
);
export const testMonkeyUpdateScenarios = createAction(
  '[Test Monkey] Update Selected Scenarios',
  props<{ payload: any }>(),
);

export const testMonkeyComplete = createAction('[Test Monkey] All Scenarios Complete');
export const testMonkeyNextScenario = createAction('[Test Monkey] Start Next Scenario');
export const testMonkeyContinueScenario = createAction('[Test Monkey] Continue Current Scenario');
export const testMonkeyPopulateScenario = createAction(
  '[Test Monkey] Populate State with Scenario',
  props<{ payload: string }>(),
);

export const testMonkeyResetState = createAction('[Test Monkey] Reset State');
export const testMonkeyStart = createAction(
  '[Test Monkey] Start Test Monkey',
  props<{ payload: boolean }>(),
);
export const testMonkeyStop = createAction('[Test Monkey] State Population Complete');
export const testMonkeyToggle = createAction(
  '[Test Monkey] Toggle Test Mode',
  props<{ payload: boolean }>(),
);

export const testMonkeyUpdatePersonalId = createAction(
  '[Test Monkey] Update Personal ID',
  props<{ payload: string }>(),
);
export const testMonkeyUpdateSelectedAccountTo = createAction('[Test Monkey] Update Account To');
export const testMonkeyUpdateSelectedJointAccounts = createAction(
  '[Test Monkey] Update Joint From Accounts',
);
export const testMonkeyUpdateSelectedMinorAccounts = createAction(
  '[Test Monkey] Update Minor From Accounts',
);
export const testMonkeyMoveNew = createAction('[Test Monkey] New Account');
export const testMonkeyMoveExisting = createAction('[Test Monkey] Existing Account');
export const testMonkeyUpdateDeathVerified = createAction(
  '[Test Monkey] Update death verified',
  props<{ payload: boolean }>(),
);

export const tMonkeyIRASpAssumeTradEx = createAction(
  '[Test Monkey] IRA Spouse Assume Traditional Existing',
);
export const tMonkeyIRASpAssumeRothEx = createAction(
  '[Test Monkey] IRA Spouse Assume Roth Existing',
);

export const tMonkeyIRASpAssumeTradNew = createAction(
  '[Test Monkey] IRA Spouse Assume Traditional New',
);
export const tMonkeyIRASpAssumeRothNew = createAction('[Test Monkey] IRA Spouse Assume Roth New');

export const tMonkeyIRASpInheritedTradNew = createAction(
  '[Test Monkey] IRA Spouse Inherit Traditional New',
);
export const tMonkeyIRASpInheritedRothNew = createAction(
  '[Test Monkey] IRA Spouse Inherit Roth New',
);

export const tMonkeyIRANonTradNew = createAction('[Test Monkey] IRA Non-Spouse Traditional New');
export const tMonkeyIRANonRothNew = createAction('[Test Monkey] IRA Non-Spouse Roth New');
export const tMonkeyIRANonTradNewByRelationship = createAction(
  '[Test Monkey] IRA Non-Spouse Traditional New - By Relationship',
);
export const tMonkeyIRANonRothNewByRelationship = createAction(
  '[Test Monkey] IRA Non-Spouse Roth New - By Relationship',
);

export const tMonkeyJointSpEx = createAction('[Test Monkey] JOINT Spouse Existing');
export const tMonkeyJointNonEx = createAction('[Test Monkey] JOINT Non-Spouse Existing');
export const tMonkeyJointSpNew = createAction('[Test Monkey] JOINT Spouse New');
export const tMonkeyJointNonNew = createAction('[Test Monkey] JOINT Non-Spouse New');

export const tMonkeyIndvSpEx = createAction('[Test Monkey] INDV Spouse Existing');
export const tMonkeyIndvNonEx = createAction('[Test Monkey] INDV Non-Spouse Existing');
export const tMonkeyIndvSpNew = createAction('[Test Monkey] INDV Spouse New');
export const tMonkeyIndvNonNew = createAction('[Test Monkey] INDV Non-Spouse New');

export const tMonkeyIndvExecSpNew = createAction('[Test Monkey] INDV Spouse Executor New');
export const tMonkeyIndvExecNonNew = createAction('[Test Monkey] INDV Non-Spouse Executor New');

export const tMonkeyIndvMinorNew = createAction('[Test Monkey] Minor INDV  New');
export const tMonkeyIndvMinorEx = createAction('[Test Monkey] Mnior INDV Ex');
